import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import './ErrorDisplay.scss'

const ErrorDisplay = ({
    icon = "fa-exclamation-triangle",
    title = "Something went wrong",
    description = "Please try again later",
    actionLabel,
    onAction,
    className = "",
}) => {
    return (
        <div className={`error-display-container ${className}`}>
            <div className="error-display-icon">
                <i className={`fas ${icon}`}></i>
            </div>
            <div>
                <h3 className="error-display-title">{title}</h3>
                <p className="error-display-description">{description}</p>
                {actionLabel && onAction && (
                    <Button onClick={onAction} className="error-display-action-button">
                        {actionLabel}
                    </Button>
                )}
            </div>
        </div>
    )
}

export default ErrorDisplay;